import { EcommerceAPIApi as EcommerceApi, GuestPassSaveRequest, ParkingPassPurchaseRequest } from '@parkingbase/ecommerce-api-demo';
import { PAYMENT_TIMEOUT_MS } from '@/lib/api/payment-timeout';
import { BaseApiService } from './baseApi.service';

export class GuestPassService extends BaseApiService {
  protected guestPassApi: EcommerceApi;

  constructor() {
    super();
    this.guestPassApi = new EcommerceApi(this.apiConfig, undefined, this.apiClient);
  }

  async getGuestPasses() {
    const response = await this.guestPassApi.getGuestPass1();
    return response.data;
  }

  async cancelGuestPass(company: string, guestPassId: string) {
    const response = await this.guestPassApi.cancelGuestPass(company, guestPassId);
    return response.data;
  }

  async createGuestPass(company: string, guestPassSaveRequest: GuestPassSaveRequest) {
    const response = await this.guestPassApi.createGuestPass(company, guestPassSaveRequest);
    return response.data;
  }

  async purchaseParkingPass(
    company: string,
    parkingPassPurchaseRequest: ParkingPassPurchaseRequest,
    recaptchaToken?: string
  ) {
    const options = recaptchaToken
      ? { headers: { 'g-recaptcha-response': recaptchaToken } }
      : undefined;
    const response = await this.guestPassApi.purchaseParkingPass(
      company,
      parkingPassPurchaseRequest,
      { ...options, timeout: PAYMENT_TIMEOUT_MS }
    );
    return response.data;
  }

  /**
   * Re-sends the email for a coupon-only Guest Pass by its coupon id (PB-1587 backend, PB-1588
   * frontend). Calls `POST /guestPass/{company}/coupon/{couponId}/resend`.
   *
   * <p>Goes through the configured axios client directly rather than the generated
   * `EcommerceApi.*` method — the generated client is regenerated from the api/ OpenAPI spec
   * out-of-band and may not yet expose this endpoint. Using the raw client lets the frontend
   * ship without blocking on a republish.
   *
   * @param company  the company id from the path
   * @param couponId the DBCoupon id of the Guest Pass coupon to resend
   * @returns the projected Reservation view of the coupon (reservationId=null, time-window null,
   *          couponId/couponCode/selectedSpecialRateId populated)
   * @throws axios error on 4xx / 5xx — callers convert via `extractApiErrorMessage`
   */
  async resendGuestPassCoupon(company: string, couponId: string) {
    const url = `${this.apiConfig.basePath}/guestPass/${encodeURIComponent(company)}/coupon/${encodeURIComponent(couponId)}/resend`;
    const response = await this.apiClient.post(url);
    return response.data;
  }
}
